import { useCallback, useEffect, useMemo, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { cn, pm } from 'lib/helpers/utility';

import { permissions as permissionsState } from 'components/state';

import List from './List';

const ModalSidebar = ({ items, className, listClassName, contentClassName }) => {
  const perms = useRecoilValue(permissionsState);
  const checkPerm = useCallback((p) => !p || pm(perms, p), [perms]);

  const computedDefault = useMemo(() => {
    for (const group of items || []) {
      if (!checkPerm(group?.permission)) continue;
      for (const child of group?.items || []) {
        if (child?.key && !child.hidden && checkPerm(child?.permission)) return child;
      }
    }
    return undefined;
  }, [items, checkPerm]);

  const [activeItem, setActiveItem] = useState(computedDefault);

  useEffect(() => {
    setActiveItem((prev) => (prev && checkPerm(prev?.permission) ? prev : computedDefault));
  }, [computedDefault, checkPerm]);

  const changeHandler = useCallback((item) => {
    setActiveItem(item);
  }, []);

  return (
    <div
      className={cn(
        'flex h-full w-full shrink-0 bg-white transition-all sm:fixed sm:opacity-100',
        className
      )}>
      <aside
        className={cn(
          'flex w-52 flex-col items-start justify-between overflow-y-auto border-0 border-r border-solid border-neutral-200',
          listClassName
        )}>
        <List items={items} onChange={changeHandler} activeItem={activeItem} />
      </aside>
      <div className={cn('flex flex-1 flex-col', contentClassName)}>{activeItem?.content}</div>
    </div>
  );
};

export default ModalSidebar;
